<div class="overlay-loader" *ngIf="eventsService.isLoading$ | async">
  <div class="logo">
    <img [priority]="true" ngSrc="/assets/images/spinner_logo.svg" alt="overlay-spinner" height="460" width="460" />
  </div>
</div>
